var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',[_c('mapbox',{attrs:{"access-token":"","map-options":{
      style: {
        glyphs:
          'https://dvn3ptw8fp74t.cloudfront.net/{fontstack}/{range}.pbf',
        version: 8,
        sources: {
          'marker-layer-source': {
            type: 'geojson',
            data: {
              type: 'FeatureCollection',
              features: [
                {
                  type: 'Feature',
                  properties: {},
                  geometry: {
                    type: 'Point',
                    coordinates: [-76.53063297271729, 39.18174077994108]
                  }
                }
              ]
            }
          }
        },
        // 'marker' layers
        layers: [
          {
            id: 'marker-layer-bottom',
            type: 'circle',
            source: 'marker-layer-source'
          },
          {
            id: 'marker-layer-polygons',
            type: 'circle',
            source: 'marker-layer-source'
          },
          {
            id: 'marker-layer-lines',
            type: 'circle',
            source: 'marker-layer-source'
          },
          {
            id: 'marker-layer-points',
            type: 'circle',
            source: 'marker-layer-source'
          }
        ]
      },
      center: [-122.937613, 50.099706],
      zoom: 12,
      bearing: 150,
      pitchWithRotate: false,
      boxZoom: false,
      // Added so layers can call geojson from urls directly and this add the auth token
      transformRequest: function (url, resourceType) {
        if (
          resourceType === 'Source' &&
          url.startsWith('https://api2.alchemymapping.com')
        ) {
          return {
            url: url,
            headers: { Authorization: 'Bearer ' + this$1.computedAuthToken }
          };
        }
      }
    },"geolocate-control":{
      show: true,
      position: 'top-right',
      options: {
        positionOptions: {
          enableHighAccuracy: true,
          trackUserLocation: true,
          showUserHeading: true
        }
      }
    }},on:{"map-init":_vm.mapInitialized,"map-load":_vm.mapLoad,"map-moveend":_vm.mapMoveEnd,"map-click":_vm.mapClicked,"geolocate-geolocate":_vm.mapGeolocate}}),_c('div',{attrs:{"id":"latlng"}},[_vm._v("\n    "+_vm._s(_vm.mouse.lat.toFixed(7))+", "+_vm._s(_vm.mouse.lng.toFixed(7))+"\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }